import { CategoryData } from '../../../../types/types';

export const objets: CategoryData = {
    // Objets d'éducation - CONFIRMÉS
    'Buku (Livre)': {
        translation: 'Livre',
        translationEn: 'Book',
        illustration: '📖',
        audio: 'Li-buku',
        example: 'Buku ya mwana ezali na mesa. (Le livre de l\'enfant est sur la table.)',
        exampleEn: 'Buku ya mwana ezali na mesa. (The child\'s book is on the table.)'
    },
    'Mpemba (Crayon)': {
        translation: 'Crayon',
        translationEn: 'Pencil',
        illustration: '✏️',
        audio: 'Li-mpemba',
        example: 'Mpemba ezali likolo ya buku. (Le crayon est sur le livre.)',
        exampleEn: 'Mpemba ezali likolo ya buku. (The pencil is on the book.)'
    },

    // Mobilier - BASIQUE
    'Mesa (Table)': {
        translation: 'Table',
        translationEn: 'Table',
        illustration: '🪑',
        audio: 'Li-mesa',
        example: 'Mesa ezali kati ya ndako. (La table est dans la maison.)',
        exampleEn: 'Mesa ezali kati ya ndako. (The table is inside the house.)'
    },
    'Kiti (Chaise)': {
        translation: 'Chaise',
        translationEn: 'Chair',
        illustration: '🪑',
        audio: 'Li-kiti',
        example: 'Nazali kovanda na kiti. (Je suis assis sur la chaise.)',
        exampleEn: 'Nazali kovanda na kiti. (I am sitting on the chair.)'
    },

    // Maison - ESSENTIELS
    'Ndako (Maison)': {
        translation: 'Maison',
        translationEn: 'House',
        illustration: '🏠',
        audio: 'Li-ndako',
        example: 'Ndako na biso ezali monene. (Notre maison est grande.)',
        exampleEn: 'Ndako na biso ezali monene. (Our house is big.)'
    },
    'Ekuke (Porte)': {
        translation: 'Porte',
        translationEn: 'Door',
        illustration: '🚪',
        audio: 'Li-ekuke',
        example: 'Ekuke ya ndako ezali ya pembe. (La porte de la maison est blanche.)',
        exampleEn: 'Ekuke ya ndako ezali ya pembe. (The door of the house is white.)'
    },


    // Ustensiles - VÉRIFIÉS
    'Mbeki (Assiette)': {
        translation: 'Assiette',
        translationEn: 'Plate',
        illustration: '🍽️',
        audio: 'Li-mbeki',
        example: 'Mbeki ezali na mesa. (L\'assiette est sur la table.)',
        exampleEn: 'Mbeki ezali na mesa. (The plate is on the table.)'
    },
    'Kopo (Tasse/Verre)': {
        translation: 'Tasse/Verre',
        translationEn: 'Cup/Glass',
        illustration: '🥤',
        audio: 'Li-kopo',
        example: 'Kopo ya mayi ezali na mesa. (Le verre d\'eau est sur la table.)',
        exampleEn: 'Kopo ya mayi ezali na mesa. (The glass of water is on the table.)'
    },
    'Mbeli (Couteau)': {
        translation: 'Couteau',
        translationEn: 'Knife',
        illustration: '🔪',
        audio: 'Li-mbeli',
        example: 'Mbeli ezali pene ya mbeki. (Le couteau est près de l\'assiette.)',
        exampleEn: 'Mbeli ezali pene ya mbeki. (The knife is near the plate.)'
    },

    // Objets personnels - SÛRS
    'Saki (Sac)': {
        translation: 'Sac',
        translationEn: 'Bag',
        illustration: '👜',
        audio: 'Li-saki',
        example: 'Saki ya mwana ezali na école. (Le sac de l\'enfant est à l\'école.)',
        exampleEn: 'Saki ya mwana ezali na école. (The child\'s bag is at school.)'
    },
    'Bilamba (Vêtements)': {
        translation: 'Vêtements',
        translationEn: 'Clothes',
        illustration: '👕',
        audio: 'Li-bilamba',
        example: 'Bilamba na ngai ezali petepete. (Mes vêtements sont propres.)',
        exampleEn: 'Bilamba na ngai ezali petepete. (My clothes are clean.)'
    },

    // Outils domestiques - BASIQUES
    'Suka (Balai)': {
        translation: 'Balai',
        translationEn: 'Broom',
        illustration: '🧹',
        audio: 'Li-suka',
        example: 'Nazali kosukola na suka. (Je balaie avec le balai.)',
        exampleEn: 'Nazali kosukola na suka. (I am sweeping with the broom.)'
    },


    // Contenants - ESSENTIELS
    'Mboto (Bouteille)': {
        translation: 'Bouteille',
        translationEn: 'Bottle',
        illustration: '🍾',
        audio: 'Li-mboto',
        example: 'Mboto ya mayi ezali na mesa. (La bouteille d\'eau est sur la table.)',
        exampleEn: 'Mboto ya mayi ezali na mesa. (The bottle of water is on the table.)'
    },
    'Nzungu (Pot/Marmite)': {
        translation: 'Pot/Marmite',
        translationEn: 'Pot/Cooking pot',
        illustration: '🍲',
        audio: 'Li-nzungu',
        example: 'Nzungu ezali na moto. (La marmite est sur le feu.)',
        exampleEn: 'Nzungu ezali na moto. (The pot is on the fire.)'
    },

    // Transport - SIMPLE
    'Motuka (Véhicule)': {
        translation: 'Véhicule/Voiture',
        translationEn: 'Vehicle/Car',
        illustration: '🚗',
        audio: 'Li-motuka',
        example: 'Motuka ezali na nzela. (La voiture est sur la route.)',
        exampleEn: 'Motuka ezali na nzela. (The car is on the road.)'
    },

    // Matériaux - NATURELS
    'Libanga (Pierre)': {
        translation: 'Pierre',
        translationEn: 'Stone',
        illustration: '🪨',
        audio: 'Li-libanga',
        example: 'Libanga ezali na mabele. (La pierre est par terre.)',
        exampleEn: 'Libanga ezali na mabele. (The stone is on the ground.)'
    },
    'Nzete (Bois/Arbre)': {
        translation: 'Bois/Arbre',
        translationEn: 'Wood/Tree',
        illustration: '🌳',
        audio: 'Li-nzete',
        example: 'Nzete ezali na zamba. (L\'arbre est dans la forêt.)',
        exampleEn: 'Nzete ezali na zamba. (The tree is in the forest.)'
    },

    // Éclairage - BASIQUE
    'Mwinda (Lumière/Lampe)': {
        translation: 'Lumière/Lampe',
        translationEn: 'Light/Lamp',
        illustration: '💡',
        audio: 'Li-mwinda',
        example: 'Mwinda ezali na ndako. (La lampe est dans la maison.)',
        exampleEn: 'Mwinda ezali na ndako. (The lamp is in the house.)'
    }
};

export default objets;
